import { render, staticRenderFns } from "./DetailDocument.vue?vue&type=template&id=b0cbbba2&scoped=true"
import script from "./DetailDocument.vue?vue&type=script&lang=js"
export * from "./DetailDocument.vue?vue&type=script&lang=js"
import style0 from "./DetailDocument.vue?vue&type=style&index=0&id=b0cbbba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0cbbba2",
  null
  
)

export default component.exports